import React, { useState } from "react";
import { useIntl } from "react-intl";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import FormTitle from "./FormTitle";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formSection: {
      marginBottom: theme.spacing(3)
    },
    formFieldGrid: {
      marginBottom: theme.spacing(2)
    },
    menuPaper: {
      maxHeight: theme.spacing(48)
    }
  })
);

interface IProps {
  formik: any;
}

function PreviousExperiencesForm(props: IProps) {
  const classes = useStyles();
  const intl = useIntl();
  const [isCurrentRole, setIsCurrentRole] = useState(false);

  const year = new Date().getFullYear();
  const years = Array.from(new Array(75), (val, index) => year - index);

  const handleIsCurrentRoleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsCurrentRole(event.target.checked);
    props.formik.handleChange(event);

    if (event.target.checked) {
      props.formik.setFieldValue("PreviousExperienceEndDate", "", false);
    }
  };

  return (
    <React.Fragment>
      <FormTitle title={intl.formatMessage({ id: "PREVIOUS_EXPERIENCES_TITLE" })} />
      <Grid className={classes.formSection} container spacing={3}>
        <Grid className={classes.formFieldGrid} item xs={12} sm={8} md={8}>
          <TextField
            fullWidth
            variant="outlined"
            name="PreviousCompanyAndTitle"
            label={intl.formatMessage({ id: "PREVIOUS_COMPANY_AND_TITLE_LABEL" })}
            value={props.formik.values.PreviousCompanyAndTitle}
            onBlur={props.formik.handleBlur}
            onChange={props.formik.handleChange}
            error={
              props.formik.touched.PreviousCompanyAndTitle &&
              Boolean(props.formik.errors.PreviousCompanyAndTitle)
            }
            helperText={
              props.formik.touched.PreviousCompanyAndTitle &&
              props.formik.errors.PreviousCompanyAndTitle
            }
          />
        </Grid>
        <Grid className={classes.formFieldGrid} item xs={12} sm={4} md={4}>
          <TextField
            fullWidth
            variant="outlined"
            name="PreviousPosition"
            label={intl.formatMessage({ id: "PREVIOUS_POSITION_LABEL" })}
            value={props.formik.values.PreviousPosition}
            onBlur={props.formik.handleBlur}
            onChange={props.formik.handleChange}
            error={
              props.formik.touched.PreviousPosition && Boolean(props.formik.errors.PreviousPosition)
            }
            helperText={
              props.formik.touched.PreviousPosition && props.formik.errors.PreviousPosition
            }
          />
        </Grid>
        <Grid className={classes.formFieldGrid} item xs={12} sm={6} md={4}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              id="start-date-select-outlined-label"
              error={
                props.formik.touched.PreviousExperienceStartDate &&
                Boolean(props.formik.errors.PreviousExperienceStartDate)
              }
            >
              {intl.formatMessage({ id: "START_DATE_LABEL" })}
            </InputLabel>
            <Select
              labelId="start-date-select-outlined-label"
              label={intl.formatMessage({ id: "START_DATE_LABEL" })}
              name="PreviousExperienceStartDate"
              value={props.formik.values.PreviousExperienceStartDate}
              onBlur={props.formik.handleBlur}
              onChange={props.formik.handleChange}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
              error={
                props.formik.touched.PreviousExperienceStartDate &&
                Boolean(props.formik.errors.PreviousExperienceStartDate)
              }
            >
              {years.map((year, index) => {
                return (
                  <MenuItem key={index} value={year}>
                    {year}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              error={
                props.formik.touched.PreviousExperienceStartDate &&
                Boolean(props.formik.errors.PreviousExperienceStartDate)
              }
            >
              {props.formik.touched.PreviousExperienceStartDate &&
                props.formik.errors.PreviousExperienceStartDate}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid className={classes.formFieldGrid} item xs={12} sm={6} md={4}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              id="end-date-select-outlined-label"
              error={
                props.formik.touched.PreviousExperienceEndDate &&
                Boolean(props.formik.errors.PreviousExperienceEndDate)
              }
            >
              {intl.formatMessage({ id: "END_DATE_LABEL" })}
            </InputLabel>
            <Select
              labelId="end-date-select-outlined-label"
              label={intl.formatMessage({ id: "END_DATE_LABEL" })}
              name="PreviousExperienceEndDate"
              value={props.formik.values.PreviousExperienceEndDate}
              onBlur={props.formik.handleBlur}
              onChange={props.formik.handleChange}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
              error={
                props.formik.touched.PreviousExperienceEndDate &&
                Boolean(props.formik.errors.PreviousExperienceEndDate)
              }
              disabled={isCurrentRole}
            >
              {years.map((year, index) => {
                return (
                  <MenuItem key={index} value={year}>
                    {year}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              error={
                props.formik.touched.PreviousExperienceEndDate &&
                Boolean(props.formik.errors.PreviousExperienceEndDate)
              }
            >
              {props.formik.touched.PreviousExperienceEndDate &&
                props.formik.errors.PreviousExperienceEndDate}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid className={classes.formFieldGrid} item xs={12} sm={4} md={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCurrentRole}
                onChange={handleIsCurrentRoleCheckboxChange}
                name="IsCurrentRole"
              />
            }
            label={intl.formatMessage({ id: "IS_CURRENT_ROLE_LABEL" })}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default PreviousExperiencesForm;
